module.exports = __webpack_public_path__ + "img/744.7a009373.jpg";